import { Injectable } from '@angular/core';
import { ApiFactoryFacade } from './api-factory.facade';
import { ApiService } from './api.service';
import { IApiConfig } from './api.interface';

@Injectable()
export class ApiFactoryService extends ApiFactoryFacade {
  create(config: IApiConfig) {
    return new ApiService(config);
  }
}
